export const signInCallbackParams = ['code', 'magic_auth_code', 'state'];

export const SIGN_IN_CALLBACK_PATHNAME = '/';

export const OIDC_PARAM = 'oidc';
